module.exports = __webpack_public_path__ + "static/img/a127.502a72f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a127.jpg
// module id = NNoc
// module chunks = 0